var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.723,
    height: 25.63,
    viewBox: "0 0 41.723 25.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloudy",
    transform: "translate(-15.139 -23.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27993",
    "data-name": "Path 27993",
    d: "M30.139,23.186a9.012,9.012,0,0,0-8.056,5,6.921,6.921,0,0,0-1.078,13.762,45.537,45.537,0,0,0,7.966.571,41.189,41.189,0,0,0,7.63-.44c4.093-.739,4.7-3.642,4.7-5.306a5.4,5.4,0,0,0-2.171-4.319c0-.089,0-.179,0-.268A9.009,9.009,0,0,0,30.139,23.186Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27994",
    "data-name": "Path 27994",
    d: "M37,33.561a7,7,0,0,0-13.615-3.2,4.947,4.947,0,0,0-1.248-.176,5,5,0,0,0-5,5,5.055,5.055,0,0,0,4.216,4.792,43.509,43.509,0,0,0,7.617.54,38.9,38.9,0,0,0,7.274-.408c2.079-.376,3.059-1.453,3.059-3.338A3.4,3.4,0,0,0,37,33.561Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27995",
    "data-name": "Path 27995",
    d: "M22.139,32.271a4.987,4.987,0,0,1,1.248.176,6.992,6.992,0,0,1,13.666.779,6.992,6.992,0,0,0-13.666-2.864,4.947,4.947,0,0,0-1.248-.176,5,5,0,0,0-5,5,4.586,4.586,0,0,0,.118,1.026,5,5,0,0,1,4.882-3.941Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27996",
    "data-name": "Path 27996",
    d: "M44.254,27.772a10.2,10.2,0,0,0-8.681,4.8,7.51,7.51,0,0,0-7.735,3.851,5.936,5.936,0,0,0-5.62,5.921c0,2.936,2.18,5.25,5.554,5.893,2.206.421,5.4.577,11.768.577a105.66,105.66,0,0,0,12.019-.555c3.172-.372,5.3-2.591,5.3-5.522a5.493,5.493,0,0,0-2.359-4.52l0-.194A10.263,10.263,0,0,0,44.254,27.772Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27997",
    "data-name": "Path 27997",
    d: "M52.383,39.38a8.32,8.32,0,0,0,.121-1.357,8.248,8.248,0,1,0-15.9-3.088,5.5,5.5,0,0,0-7.479,3.619,3.873,3.873,0,0,0-.981-.139,3.929,3.929,0,0,0-3.929,3.929c0,2.17,1.744,3.512,3.929,3.929s5.518.542,11.393.542a103.934,103.934,0,0,0,11.786-.542c2.131-.25,3.536-1.583,3.536-3.536a3.526,3.526,0,0,0-2.479-3.357Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27998",
    "data-name": "Path 27998",
    d: "M28.147,40.449a3.917,3.917,0,0,1,.981.138,5.5,5.5,0,0,1,7.479-3.619,8.244,8.244,0,0,1,15.824,2.045,7.72,7.72,0,0,0,.073-.992,8.248,8.248,0,1,0-15.9-3.088,5.5,5.5,0,0,0-7.479,3.619,3.872,3.872,0,0,0-.981-.138,3.929,3.929,0,0,0-3.929,3.929,3.607,3.607,0,0,0,.154,1,3.918,3.918,0,0,1,3.775-2.9Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudy);
export default __webpack_public_path__ + "static/media/cloudy.52e3c84069d2d8aecdd3e00f65930ebf.svg";
export { ForwardRef as ReactComponent };